import { render, staticRenderFns } from "./postulate.vue?vue&type=template&id=4984e4c3&scoped=true"
import script from "./postulate.vue?vue&type=script&lang=js"
export * from "./postulate.vue?vue&type=script&lang=js"
import style0 from "./postulate.vue?vue&type=style&index=0&id=4984e4c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984e4c3",
  null
  
)

export default component.exports